@switch (priorite) {
	@case ("Urgent") {
		<i class="las la-angle-double-up align-middle me-1 text-danger"></i>
	}
	@case ("Haute") {
		<i class="las la-angle-up align-middle me-1 text-danger"></i>
	}
	@case ("Moyenne") {
		<i class="las la-equals align-middle me-1 text-warning"></i>
	}
	@case ("Faible") {
		<i class="las la-angle-down align-middle me-1 text-info"></i>
	}
}
